
import env from "../../../environment.js";

// Read from localStorage config for calidad, supporting dot-paths and nested objects
export const getCalidadLS = (keyPath) => {
  try {
    const raw = localStorage.getItem(`${env.appName}-calidad`);
    if (!raw) return undefined;
    const dataCalidad = JSON.parse(raw);
    if (!keyPath) return dataCalidad;
    // Support nested access using dot notation, with fallback to flat keys
    if (keyPath.includes('.')) {
      return keyPath.split('.').reduce((acc, k) => (acc && acc[k] !== undefined ? acc[k] : undefined), dataCalidad);
    }
    // Try flat key first, then fallback into info_muestra nested object
    if (dataCalidad && Object.prototype.hasOwnProperty.call(dataCalidad, keyPath)) {
      return dataCalidad[keyPath];
    }
    return dataCalidad?.info_muestra?.[keyPath];
  } catch (e) {
    return undefined;
  }
};
